

function getRedGreenGradient(value: number): string {
    const colors = [
        "#2ecc4033",
        "#b6e64933",
        "#ffd92b33",
        "#ffae4233",
        "#ff704333",
        "#ff413633",
    ];
    const idx = Math.max(0, Math.min(5, value - 1));
    return colors[idx];
}

export function RankingCell({ value }: { value: number }) {
    const color = getRedGreenGradient(value);
    return (
        <div
            style={{ backgroundColor: color }}
            className="w-10 h-10 bg-opacity-25 flex flex-row justify-center items-center text-xl font-semibold rounded-md"
        >
            {value}
        </div>
    );
}